import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import type RouterService from '@ember/routing/router-service';
import type Controller from '@ember/controller';
import type Transition from '@ember/routing/transition';

export default class ScansScanProcessingRoute extends Route {
  @service declare betaToggle: BetaToggleService;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.betaToggle.isPlatformAdmin) this.router.transitionTo('scans');
  }

  model() {
    return this.modelFor('scans.scan');
  }

  /**
   * Only UI-only view state is reset here. The busy flags (isArchiving,
   * etc.) moved onto the scan record — see app/models/scan.ts — so they
   * no longer need resetting: each scan
   * carries its own, and the controller reusing a different `model` on the
   * next visit can never see another scan's leftover state.
   */
  resetController(
    controller: Controller,
    isExiting: boolean,
    transition: Transition,
  ) {
    if (isExiting && transition.targetName !== 'error') {
      controller.set('isCloneBoxExpanded', false);
      controller.set('isProductDiscoveryExpanded', false);
      controller.set('isAddContextExpanded', false);
      controller.set('isReportsUploadExpanded', false);
      controller.set('contextValue', null);
      controller.set('isLeavingForList', false);
      controller.set('repoStatusFilter', 'ALL');
    }
  }
}
